import { Component, ElementRef, inject, signal, ViewEncapsulation, viewChild } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

import { NavItem } from '@models/nav-item';
import { NavService } from '@services/nav.service';

@Component({
    selector: 'app-sidenav-mobile',
    standalone: true,
    imports: [MatIconModule, MatButtonModule, MatDividerModule],
    templateUrl: './sidenav-mobile.component.html',
    styleUrl: './sidenav-mobile.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class SidenavMobileComponent {
    readonly nav = inject(NavService);
    readonly #sheetRef = inject(MatBottomSheetRef<SidenavMobileComponent>);
    readonly #router = inject(Router);

    readonly sheetEl = viewChild.required<ElementRef<HTMLDivElement>>('sheetEl');

    activeItem = signal<NavItem | null>(null);

    // ── Drag to dismiss ───────────────────────────────────────────────────────
    #dragStartY = 0;
    #isDragging = false;
    #translateY = 0;
    readonly #CLOSE_THRESHOLD = 80;

    onDragStart(event: PointerEvent): void {
        (event.target as HTMLElement).setPointerCapture(event.pointerId);
        this.#dragStartY = event.clientY;
        this.#isDragging = true;
    }

    onDragMove(event: PointerEvent): void {
        if (!this.#isDragging) return;
        this.#translateY = Math.max(0, event.clientY - this.#dragStartY);
        this.sheetEl().nativeElement.style.transform = this.#translateY > 0 ? `translateY(${this.#translateY}px)` : '';
    }

    onDragEnd(_event: PointerEvent): void {
        this.#isDragging = false;
        if (this.#translateY >= this.#CLOSE_THRESHOLD) {
            this.#sheetRef.dismiss();
        } else {
            this.#translateY = 0;
            this.sheetEl().nativeElement.style.transform = '';
        }
    }

    // ── Navigation ────────────────────────────────────────────────────────────
    openSubLevel(item: NavItem): void {
        this.activeItem.set(item);
    }
    goBack(): void {
        this.activeItem.set(null);
    }

    navigateTo(route: string): void {
        this.#sheetRef.dismiss();
        this.#router.navigateByUrl(route);
    }

    dismiss(): void {
        this.#sheetRef.dismiss();
    }
}
